import {
  BusinessChallengesEnum,
  ChallengeUpdateArgsChallengeNumber,
} from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../../application/components/ApplicationPageContent';
import BackgroundImage from '../../../application/images/Leftsection8.svg';
import { challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';
import { useParams } from 'wouter';
import { navigate } from 'wouter/use-browser-location';
import { ROUTES } from '../../../routes/consts';

type FormValues = {
  secondBusinessChallenge: BusinessChallengesEnum | null;
  secondBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeTwo = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { data: challengeData } = BusinessChallenges.useGetOrganizationBusinessChallenges(
    parseInt(organizationId),
  );

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      secondBusinessChallenge: challengeData?.challenges?.[1]?.challenge as BusinessChallengesEnum,
      secondBusinessChallengeDescription: challengeData?.challenges?.[1]?.challengeContext,
    },
  });

  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(
            parseInt(organizationId),
          ),
        });
        navigate(`/platform${ROUTES.DASHBOARD}`);
      },
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    if (data.secondBusinessChallenge && data.secondBusinessChallengeDescription) {
      updateChallengeMutator.mutate({
        organizationId: parseInt(organizationId),
        data: {
          challenge_number: challengeData?.challenges?.[1]
            ?.challengeNumber as ChallengeUpdateArgsChallengeNumber,
          challenge_value: data.secondBusinessChallenge,
          challenge_context: data.secondBusinessChallengeDescription,
        },
      });
    }
  };

  return (
    <ChallengeFormBackground onSubmit={handleSubmit(submit)} backgroundImage={BackgroundImage}>
      <ApplicationPageContent
        title="Tell us about the challenges you're working through"
        description={
          'The more context you share, the better we can recommend projects that align with your needs.'
        }
      >
        <FormsInputDropdown
          control={control}
          name='secondBusinessChallenge'
          label='Second business challenge'
          placeholder='Select your second challenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          items={challengeOptions}
          type='default'
          error={errors.secondBusinessChallenge}
          inputDisabled
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'secondBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.secondBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
